export const SelectOptions = [
  { label: "No", value: "0" },
  { label: "Yes", value: "1" },
];
